import React from "react";

export default function HeartPlus(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.4"
      height="10.275"
      fill="none"
      viewBox="0 0 12.4 10.275"
      {...props}
    >
      <path
        fill="#091e42"
        stroke="#091e42"
        strokeWidth="0.2"
        d="M5.587 10.078l.067.062.068-.061.559-.505h0c.3-.272.58-.522.843-.748.264-.228.52-.451.765-.67l.08-.071-.076-.075-.287-.28-.196-.19-.09-.09-.066-.063-.069.06a89.108 89.108 0 00-1.53 1.345c-.879-.81-1.611-1.493-2.197-2.05l-.069.072.07-.072c-.6-.57-1.072-1.067-1.417-1.49-.346-.425-.584-.799-.72-1.123a2.558 2.558 0 01-.204-.997c0-.577.183-1.054.546-1.439.361-.382.825-.575 1.4-.575.441 0 .853.136 1.237.41.384.276.692.66.922 1.155l.027.058h.795l.027-.058c.24-.505.552-.89.936-1.16.384-.271.796-.405 1.237-.405.514 0 .927.158 1.247.47.324.315.526.711.605 1.191l.014.084h1.006l-.018-.115A3.295 3.295 0 0010.16.88C9.644.36 9.003.1 8.245.1c-.507 0-.982.118-1.424.353-.411.22-.799.554-1.163 1A3.47 3.47 0 004.55.474 3.052 3.052 0 003.064.1C2.228.1 1.522.394.954.982.383 1.57.1 2.288.1 3.132c0 .428.068.833.204 1.213.136.38.367.782.69 1.206.321.423.745.895 1.27 1.415a74.4 74.4 0 001.973 1.87h0zm3.922-2.242v.1h1.018V6.163H12.3V5.145h-1.773V3.373H9.51v1.772H7.736v1.018H9.51z"
      >
      </path>
    </svg>
  );
}
